import { get, isEmpty } from 'lodash'

const isLoading = state => get(state, 'vista360OrderDetailLoad.loading')
const hasErrors = state => !isEmpty(get(state, 'vista360OrderDetailLoad.error'))

export const selectors = {
  isLoading,
  hasErrors,
}
